import { generateProductDetailUrl as generateUrlPath, getCollectionSlug } from './urlUtils';

/**
 * Generate product detail URL for a product object
 * @param {object} product - Product object
 * @returns {string} - Product detail URL
 */
export const generateProductDetailUrl = (product) => {
  if (!product) return '/';
  
  // Try to use the new collection-based URL format
  let collectionSlug = null;
  
  // Check if CollectionId is populated (object) or just an ID
  if (product.CollectionId) {
    if (typeof product.CollectionId === 'object' && product.CollectionId.slug) {
      // CollectionId is populated, use the slug directly
      collectionSlug = product.CollectionId.slug;
    } else if (typeof product.CollectionId === 'string') {
      // CollectionId is just an ID, we can't generate URL properly without slug
      // Try to use Collection_Name as fallback
      if (product.Collection_Name) {
        collectionSlug = getCollectionSlug(product.Collection_Name);
      } else {
        // Last resort: use 'products' as a generic collection
        collectionSlug = 'products';
      }
    }
  } else if (product.Collection_Name) {
    // Use Collection_Name if available
    collectionSlug = getCollectionSlug(product.Collection_Name);
  } else {
    // If no collection info is available, use 'products' as generic collection
    collectionSlug = 'products';
  }
  
  // If we have both collection slug and product slug, use new format
  if (collectionSlug && product.slug) {
    return generateUrlPath(collectionSlug, product.slug);
  }
  
  // Final fallback - use 'products' as collection if we only have an ID
  return generateUrlPath('products', product.slug || product.id);
};

/**
 * Update all product card links to use new URL format
 * @param {object} product - Product object
 * @returns {string} - Product detail URL
 */
export const getProductCardUrl = (product) => {
  return generateProductDetailUrl(product);
};
